// @ts-nocheck
import { Link } from "@tanstack/react-router";
import { CalendarDays, CircleUserRound, Cog, MessagesSquare, Route, Timer, Users } from "lucide-react";
import ChatsWatcher from "./Chat/ChatsWatcher";
import { useEffect, useState } from "react";
import getAuth from "../msalAuth";

function Nav() {
  const [userID, setUserID] = useState();
  const [userType, setUserType] = useState()
  useEffect(() => {
    const auth = getAuth();
    if (auth) setUserID(auth.id);
  }, []);
  return (
    <div className="dock z-10 bg-accent text-white dock-xl">
      <Link to="/visits">
        <Route />
        <span className="dock-label">Visits</span>
      </Link>

      <Link to="/clients">
        <Users />
        <span className="dock-label">Clients</span>
      </Link>

      {/* {userType == "H.C" && ( */}
        <Link to="/adhoc">
          <Timer />
          <span className="dock-label">AdHoc</span>
        </Link>
      {/* )} */}
      {/* <ChatsWatcher /> */}
      {/* <Link to="/chats"> */}
      <a href="https://chat.theehgroup.com" target="_blank" rel="noopener noreferrer">
        <MessagesSquare />
        <span className="dock-label">Chat</span>
      </a>
      {/* </Link> */}
      <Link to="/me">
        {/* <CalendarDays /> */}
        <CircleUserRound />
        <span className="dock-label">Me</span>
      </Link>
      <Link to="/settings">
        <Cog />
        <span className="dock-label">Settings</span>
      </Link>
    </div>
  );
}

export default Nav;
